import React from "react";
import { Link } from "react-router-dom";

function Branding() {
  return (
    <div className="branding">
      <div className="header-organization-banner">
        <Link to="/">
          <img
            src={`/${process.env.REACT_APP_IMAGE_DIR}/banner/banner-hwts.png`}
            alt="Hazardous Waste Tracking System banner"
          />
        </Link>
      </div>
    </div>
  );
}

export default Branding;
